import { AgentDealUpdateRequest } from '@repo/database/src/types';

export type UpdateAgentDealUpdateRequestDto = Partial<
  Omit<
    AgentDealUpdateRequest,
    'id' | 'createdAt' | 'updatedAt' | 'userId' | 'agentDealId' | 'createdBy' | 'currentCycle' | 'validFrom'
  >
>;
